<template>
  <div class="property_wrap">
    <div class="pro_top">{{property.label}}设置</div>
    <div class="pro_con">
      <el-form ref="form" label-width="80px">
        <el-form label-width="80px">
          <el-form-item label="组件标题:">
            <el-input v-model="property.label"></el-input>
          </el-form-item>
        </el-form>
        <el-form-item label="内容:">
          <el-input type="textarea" v-model="property.body" class="companytext"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["property"],
    data() {
      return {
        dialogVisible: false,
        fileList:[],
        form: {
          body: ''
        }
      };
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      property: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    },
    created(){
    },
    mounted() {
      // props 是单向数据流，通过触发 update 事件绑定 formData，
      // 将 data 里的 form 指向父组件通过 formData 绑定的那个对象
      // 父组件在绑定 formData 的时候，需要加上 .sync
      this.$emit('update:property', this.form)
    },
    methods: {
    }
  };
</script>

